import { Provider } from "react-redux";
import { ConflictResolutionDialog } from "./components/shared/conflict-resolution-dialog";
import { AuditProvider } from "./contexts/audit-context";
import { SiteProvider } from "./contexts/site-context";
import { SolarTemplateProvider } from "./contexts/solar-template-context";
import { ThemeProvider } from "./contexts/theme-context";
import { AuthProvider } from "./hooks/use-auth";
import store from "./redux/store.js";

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <Provider store={store}>
      <AuthProvider>
        <ThemeProvider>
          <SiteProvider>
            <SolarTemplateProvider>
              <AuditProvider>{children}</AuditProvider>
              <ConflictResolutionDialog />
            </SolarTemplateProvider>
          </SiteProvider>
        </ThemeProvider>
      </AuthProvider>
    </Provider>
  );
}
